import { configureStore } from "@reduxjs/toolkit";
import catalogueSlice from "./slices/catalogueSlice";
import mobileSlice from "./slices/mobile";
import windowSizeSlice from "./slices/windowSize";

export const store = configureStore({
  reducer: {
    catalogue: catalogueSlice,
    mobile: mobileSlice,
    windowSize: windowSizeSlice
  },
});

store.subscribe(() => {
  localStorage.setItem(
    "catalogueItems",
    JSON.stringify(store.getState().catalogue)
  );
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
